export default {
  footer: '© {year} • Núcleo P • Menos discurso, mais resultado.',
  menu: {
    product: 'Produto',
    modules: 'Módulos',
    contact: 'Contato',
    blog: 'Blog',
    login: 'Login',
    signup: 'Cadastro'
  },
  seo: {
    title: 'Plataforma | Nucleo P ',
    description: 'Página da plataforma técnica da Nucleo P',
    robots: false
  },
  productName: 'Platform'
}